"use client"

import { useEffect, useState } from "react"
import Link from "next/link"
import { loadOrderByIdAction } from "@/actions/orderActions"
import { useUbStorefrontState } from "@/store/ubStorefrontState"

import { CheckoutContext } from "@/lib/storefront/checkout/checkout-service"
import { Button } from "@/components/ui/components"
import { UbCheckoutConfirmationOrderLinkStoryblok } from "@/components/storyblok/component-types"

interface CheckoutConfirmationProps {
  blok: UbCheckoutConfirmationOrderLinkStoryblok
  checkoutContext: CheckoutContext
}

export default function CheckoutConfirmationOrderLinkClient(props: CheckoutConfirmationProps) {
  const { createdOrder } = useUbStorefrontState()
  const [orderDocumentNumber, setOrderDocumentNumber] = useState<string>("")

  useEffect(() => {
    if (createdOrder) {
      loadOrderByIdAction(createdOrder.id).then((order) => {
        console.dir(order)
        setOrderDocumentNumber(order?.data?.documentNumber ?? "")
      })
    }
  }, [createdOrder])

  return (
    <>
      {createdOrder && orderDocumentNumber !== "" ? (
        <Link prefetch={false} className={"cursor-pointer"} href={props.blok.orderDetailLink + "" + createdOrder.id}>
          {props.blok.showAsButton ? (
            <Button size={"defaultNoGrow"} variant={"default"} className={"bg-primary py-0 font-normal text-white"}>
              {props.blok.buttonTitle ?? "Order details"}
            </Button>
          ) : (
            <p className={"text-sm font-bold text-primary sm:text-lg"}>{orderDocumentNumber}</p>
          )}
        </Link>
      ) : (
        <>
          {props.blok.showAsButton ? (
            <Button size={"defaultNoGrow"} variant={"default"} className={"bg-primary py-0 font-normal text-white"}>
              {props.blok.buttonTitle ?? "Order details"}
            </Button>
          ) : (
            <p className={"text-sm font-bold text-primary sm:text-lg"}></p>
          )}
        </>
      )}
    </>
  )
}
